type ServiceFaqItem = {
  question: string;
  answer: string;
  category: 'Pricing' | 'Scheduling' | 'Services' | 'Warranty';
};

const serviceFaq: ServiceFaqItem[] = [
  {
    question: 'Will you recommend services I don’t need?',
    category: 'Pricing',
    answer:
      'No. Our service advisors are trained and paid to recommend only what your vehicle actually requires. If a service can safely wait, we’ll tell you so. You’ll always leave with a written record of what we did and what we noticed \u2014 never a surprise invoice.'
  },
  {
    question: 'How will I know what’s happening with my vehicle?',
    category: 'Scheduling',
    answer:
      'We’ll text you updates at every stage \u2014 check-in, diagnosis, approval requests, and when your vehicle is ready for pickup. If we notice something that wasn’t part of the original appointment, we’ll call you with options before starting any work.'
  },
  {
    question: 'What are your service center hours?',
    category: 'Scheduling',
    answer:
      'Monday\u2013Friday 7:00am\u20136:00pm, Saturday 8:00am\u20134:00pm. Closed Sundays. Early drop-off and overnight key drop available 24/7.'
  },
  {
    question: 'Do I need an appointment, or do you accept walk-ins?',
    category: 'Scheduling',
    answer:
      'We recommend booking online \u2014 most appointments are available within 48 hours. Walk-ins are welcome for oil changes, tire rotations, and recall work, but scheduled appointments get priority.'
  },
  {
    question: 'Do you service all makes and models?',
    category: 'Services',
    answer:
      'Yes. While we’re a certified Mopar\u00AE service center for Chrysler, Dodge, Jeep, Ram, and FIAT, our technicians service virtually all makes and models. Bring us your Toyota, Honda, Ford, or anything else.'
  },
  {
    question: 'Do you offer loaner vehicles or a shuttle?',
    category: 'Services',
    answer:
      'Complimentary shuttle service is available within a 10-mile radius. Loaner vehicles are available for warranty and extended-service appointments, subject to availability.'
  },
  {
    question: 'Will my factory warranty be honored?',
    category: 'Warranty',
    answer:
      'Absolutely. As a certified Mopar\u00AE service center, all factory warranty work is performed using genuine parts and certified procedures. Your warranty remains fully intact.'
  },
  {
    question: 'How do I check for open recalls?',
    category: 'Warranty',
    answer:
      'Bring your VIN or call us \u2014 we’ll check manufacturer databases and schedule any open recall work at no cost to you. You can also enter your VIN at NHTSA.gov.'
  },
  {
    question: 'How long will my service take?',
    category: 'Scheduling',
    answer:
      'Most oil changes and tire rotations are completed within an hour. Larger services have estimates provided upfront. We’ll text you a realistic ready time at check-in and update you if anything changes.'
  }
];

export default serviceFaq;
